import { render, staticRenderFns } from "./SubmissionUpdateCommentForm.vue?vue&type=template&id=3ecbd42b&scoped=true&"
import script from "./SubmissionUpdateCommentForm.vue?vue&type=script&lang=js&"
export * from "./SubmissionUpdateCommentForm.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionUpdateCommentForm.vue?vue&type=style&index=0&id=3ecbd42b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecbd42b",
  null
  
)

/* custom blocks */
import block0 from "./SubmissionUpdateCommentForm.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports